/* Continuous photo zoom, paused when the image is offscreen.
   Visibility and reduced-motion preferences never affect the static content. */
(() => {
  const targets = [...document.querySelectorAll('[data-rcb-card-motion] .rcb-card__media')]
    .filter((media) => media.querySelector('img'));
  if (!targets.length) return;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const hasObserver = 'IntersectionObserver' in window;
  const visible = new Map(targets.map((target) => [target, !hasObserver]));

  const update = () => {
    for (const target of targets) {
      const photo = target.querySelector('img');
      const ready = photo.complete && photo.naturalWidth > 0;
      const running = visible.get(target) && ready && !document.hidden && !reduced.matches;
      target.toggleAttribute('data-rcb-motion-running', Boolean(running));
    }
  };
  if (hasObserver) {
    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        visible.set(entry.target, entry.isIntersecting && entry.intersectionRatio > 0);
      }
      update();
    }, { threshold: 0 });
    for (const target of targets) observer.observe(target);
  }

  for (const target of targets) {
    const photo = target.querySelector('img');
    photo.addEventListener('load', update);
    photo.addEventListener('error', update);
  }
  document.addEventListener('visibilitychange', update);
  reduced.addEventListener?.('change', update);
  update();
})();
